export const LOGO_URL = "/photos/logo.png";

export const BUSINESS = {
  name: "ClearCo Window Cleaning",
  tagline: "Clear Views. Better Spaces.",
  phone: "720-449-1197",
  phoneHref: "tel:+17204491197",
  email: "Admin.clearco@gmail.com",
  emailHref: "mailto:admin.clearco@gmail.com",
  areas: ["Castle Rock", "Larkspur", "Parker", "& surrounding areas"],
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 5:00 PM" },
    { day: "Saturday – Sunday", time: "Closed" },
  ],
};

export const IMAGES = {
  realWork: "/photos/crew-ladder.jpg",
  realClose: "/photos/crew-detailing.jpg",
  realPortrait: "/photos/owner-portrait.jpg",
  hero: "https://images.unsplash.com/photo-1766603636700-e9d80473f40f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZSUyMGxhcmdlJTIwd2luZG93cyUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MzA0NDIxNXww&ixlib=rb-4.1.0&q=85",
  residential: "https://images.unsplash.com/photo-1775116483675-a592e6e02807?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob3VzZSUyMGxhcmdlJTIwd2luZG93cyUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MzA0NDIxNXww&ixlib=rb-4.1.0&q=85",
  commercial: "https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAxODF8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwZ2xhc3N8ZW58MHx8fHwxNzgzMDQ0MjE1fDA&ixlib=rb-4.1.0&q=85",
  solar: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA4Mzl8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMHJvb2Z8ZW58MHx8fHwxNzgzMDQ0MjE1fDA&ixlib=rb-4.1.0&q=85",
  gutter: "https://images.unsplash.com/photo-1566071634551-224a639a1c7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjY2NjV8MHwxfHNlYXJjaHwxfHxyb29mJTIwZ3V0dGVycyUyMGhvdXNlfGVufDB8fHx8MTc4MzA0NDIxNXww&ixlib=rb-4.1.0&q=85",
  realFamily: "/photos/family.jpg",
  familyPortrait: "/photos/family-portrait.jpg",
  gallery1: "https://images.unsplash.com/photo-1721620958961-cccc239cbb49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1MDZ8MHwxfHNlYXJjaHwyfHx3aW5kb3clMjBjbGVhbmluZyUyMHNxdWVlZ2VlfGVufDB8fHx8MTc4MzA0NDIxNXww&ixlib=rb-4.1.0&q=85",
  gallery2: "https://images.unsplash.com/photo-1761689502577-0013be84f1bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1MDZ8MHwxfHNlYXJjaHwzfHx3aW5kb3clMjBjbGVhbmluZyUyMHNxdWVlZ2VlfGVufDB8fHx8MTc4MzA0NDIxNXww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    key: "residential",
    title: "Residential Windows",
    blurb:
      "Streak-free interior and exterior window cleaning for homes of every size. We treat your property with care and leave every pane crystal clear.",
    image: IMAGES.residential,
    points: ["Interior & exterior", "Screens & tracks", "Sills wiped down"],
  },
  {
    key: "commercial",
    title: "Commercial Windows",
    blurb:
      "Storefronts, offices, and multi-story buildings. Reliable, scheduled cleaning that keeps your business looking its best.",
    image: IMAGES.commercial,
    points: ["Storefronts & offices", "Recurring plans", "Fully insured crew"],
  },
  {
    key: "gutter",
    title: "Gutter Cleaning",
    blurb:
      "Clogged gutters cause costly damage. We clear debris and flush your system so water flows where it should.",
    image: IMAGES.gutter,
    points: ["Debris removal", "Downspout flush", "Roofline check"],
  },
  {
    key: "solar",
    title: "Solar Panel Cleaning",
    blurb:
      "Dirty panels lose efficiency. Our gentle, purified-water process restores output and protects your investment.",
    image: IMAGES.solar,
    points: ["Efficiency boost", "Soft-wash safe", "No harsh chemicals"],
  },
];

export const GOOGLE = {
  rating: 5.0,
  count: 131,
  reviewsUrl: "https://www.google.com/maps?cid=3649544408242604279",
  writeReviewUrl: "https://search.google.com/local/writereview?placeid=&cid=3649544408242604279",
  mapsUrl: "https://www.google.com/maps?cid=3649544408242604279",
};

export const REVIEWS = [
  { name: "Sarah M.", city: "Castle Rock", text: "Our windows have never looked this clear. Professional, on time, and worth every penny." },
  { name: "Dave R.", city: "Parker", text: "ClearCo did our whole storefront. Customers noticed the difference immediately." },
  { name: "Jenna L.", city: "Larkspur", text: "They cleaned windows, gutters, and solar panels in one visit. So easy to work with." },
  { name: "Mike T.", city: "Castle Rock", text: "Fast quote, fair price, spotless results. Booked them for quarterly service." },
  { name: "Priya K.", city: "Parker", text: "Friendly crew and zero streaks. Highly recommend for any home." },
  { name: "Tom B.", city: "Larkspur", text: "Solar output went up after their cleaning. Really knew what they were doing." },
];
